import { TagColorType } from 'components/tag/Tag';

export enum TransactionStatusType {
  NEW = 'NEW',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
  INVOICE_SENT = 'INVOICE_SENT',
  PENDING = 'PENDING',
}

export enum TransactionTypeType {
  NOBUNDLE = 'NOBUNDLE',
  BUNDLE1 = 'BUNDLE1',
  BUNDLE2 = 'BUNDLE2',
  BUNDLE3 = 'BUNDLE3',
  BUNDLE4 = 'BUNDLE4',
  BUNDLE5 = 'BUNDLE5',
  BUNDLE10 = 'BUNDLE10',
  BUNDLE15 = 'BUNDLE15',
  BUNDLE20 = 'BUNDLE20',
  BUNDLE30 = 'BUNDLE30',
  BUNDLE50 = 'BUNDLE50',
  BUNDLE100 = 'BUNDLE100',
  BUNDLE200 = 'BUNDLE200',
  FIXED = 'FIXED',
  YEARLY = 'YEARLY',
}

export interface TransactionType {
  _id: string;
  type: TransactionTypeType;
  status: TransactionStatusType;
  createdAt: string;
  price: number;
  userId: string;
  shipName: string;
  shipId: string;
  serviceRequestUniqueId: string;
  invoiceSentDate: string;
}

export interface TransactionStatusOptionType {
  color: TagColorType;
  text: string;
}

export interface TransactionStatusOptionsType {
  NEW: TransactionStatusOptionType;
  REJECTED: TransactionStatusOptionType;
  PAID: TransactionStatusOptionType;
  INVOICE_SENT: TransactionStatusOptionType;
  PENDING: TransactionStatusOptionType;
}
